import React, { useMemo } from "react";
import EChart from "./EChart";
import { ECHART_TOOLTIP, ECHART_TOOLBOX, ECHART_COLORS } from "../../Utilities/echartsTheme";
import { formatNumber } from "../../Utilities/numbers";

const periodLabels = {
  today: "Today",
  yesterday: "Yesterday",
  "this-week": "This Week",
  "this-month": "This Month",
  "this-year": "This Year",
  "last-year": "Last Year",
};

const EChartsVerticalBar = ({ data, label = "Value", titleText = "" }) => {
  const option = useMemo(() => {
    const { "all-time": _, ...dataWithoutAllTime } = data || {};
    const entries = Object.entries(dataWithoutAllTime);
    const labels = entries.map(([k]) => periodLabels[k] || k);
    const values = entries.map(([, v]) => Number(v) || 0);

    return {
      tooltip: {
        ...ECHART_TOOLTIP,
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: (params) => {
          const p = params[0];
          return `<div style="font-weight:600">${p.axisValue}</div>${label}: ${formatNumber(p.value)}`;
        },
      },
      toolbox: ECHART_TOOLBOX,
      grid: { left: "3%", right: "5%", bottom: "3%", top: "10%", containLabel: true },
      xAxis: {
        type: "category",
        data: labels,
        axisLabel: { hideOverlap: true },
      },
      yAxis: {
        type: "value",
        minInterval: 1,
        axisLabel: { formatter: (v) => formatNumber(v) },
      },
      series: [
        {
          name: label,
          type: "bar",
          data: values,
          barMaxWidth: 50,
          itemStyle: {
            color: {
              type: "linear",
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: ECHART_COLORS.primaryLight },
                { offset: 1, color: ECHART_COLORS.primary },
              ],
            },
            borderRadius: [4, 4, 0, 0],
          },
          emphasis: {
            itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.15)" },
          },
          label: {
            show: true,
            position: "top",
            formatter: (p) => formatNumber(p.value),
            fontSize: 11,
            color: "#64748B",
          },
          animationDelay: (idx) => idx * 80,
        },
      ],
    };
  }, [data, label]);

  return <EChart option={option} />;
};

export default EChartsVerticalBar;
